import { useNotify } from '@globaleris/ui.library'
import { Grid, makeStyles, useTheme } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useConfirmationDialog } from '../../../../hooks'
import { GlobalNotification } from '../../../../model'
import { styles } from '../../regulatoryReports.styles'
import { CardProps, ReportCard } from '../reportCard/reportCard'

export interface ReportsContainerProps {
  commodity: number
  cards: { cardName: string }[]
  table: React.ReactElement
  onGlobalNotificationChange: (globalNotification: GlobalNotification | undefined) => void
  onClick: (props: CardProps) => void
}

export const ReportsContainer: React.FC<ReportsContainerProps> = ({ cards, table, onClick }) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  return (
    <Grid container spacing={3}>
      {cards.map((card, idx) => (
        <Grid key={`container-${idx}-${card.cardName}`} item md={7} lg={5}>
          <ReportCard key={`${idx}-${card.cardName}`} cardName={card.cardName} onClick={onClick} />
        </Grid>
      ))}

      <Grid item xs={12}>
        {table}
      </Grid>
    </Grid>
  )
}
